import store from '@/state/store'

export default (to, from, next, permissions) => {

    permissions = Array.isArray(permissions) ? permissions : permissions.split('|')

    if(!store.getters['auth/loggedIn'])
        next({ name: 'login' })
    
    let user = store.getters['auth/getUser']
    if(!user.hasAnyPermission(permissions))
        next({ name: 'error', params: { code: 403 } })
}

